import { Scope } from '../shared';

export const recommendationRSAAsset = {
  id: 'recommendation-rsa-asset',
  name: _TL_('RSA Asset'),
  scope: [Scope.Customer],
  children: [
    {
      id: 'RSAAsset',
      name: _TL_('RSA Asset'),
      route: 'recommendations/RSAAsset',
      checkPermission: permissions => permissions.IsRecommendationRSAAssetEnabled,
    },
  ],
};
